import type { TenantConfig } from '@/types/TenantConfig'

export const cobbandco: TenantConfig = {
  logo: 'assets/cobbandco/static/logo-2.png',
  themeOptions: {
    dialog: {
      headerBackground: '#ebebeb',
      backgroundColor: '#ffffff',
    },
    mobileFooter: {
      textColor: '#000000',
      priceTextColor: '#000000',
    },
  },
  teaserImageSize: {
    width: 350,
    height: 350,
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/cobbandco/static/completed.png',
      },
      completedContentOffset: {
        desktop: '-160px',
        mobile: '-100px',
      },
    },
  },
}
